/*
 * ▼ FRONTKOM-CUSTOM (2026-09-29): mobile menu — scroll the opened section to
 * the top of the drawer.
 *
 * Palo Alto's mobile drawer let every level-1 section stay open, so opening
 * FASHION then BRANDS stacked ~1900px of links in a ~590px drawer and the
 * shopper scrolled through everything that opened (Hans/Rikke, plan of
 * 2026-09-02, "den enkle forbedringen"). The fix has two halves:
 *
 *   1. One section open at a time — the theme's own `data-collapsible-single`
 *      on the menu's <collapsible-elements> (sections/mobile-menu.liquid),
 *      the same mode the cart and accordions use. No JS here for that.
 *   2. This file: once a section has opened, scroll it to the top of the
 *      drawer so its links start where the shopper is looking.
 *
 * Open state is read from the dropdown's rendered height, not aria-expanded —
 * the theme tracks it with a class and does not update aria-expanded.
 * Link order, the flattened brand list (BOMA-73) and desktop navigation are
 * untouched. Loaded only by sections/mobile-menu.liquid.
 * Re-synced 2026-09-29: GitHub emitted no push event for #930's merge, so the
 * Shopify theme never received it.
 */
(function () {
  if (window.bomaMobileMenuScroll) return;
  window.bomaMobileMenuScroll = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.mobile-nav__trigger--level-1');
    if (!trigger) return;

    var dropdown = document.getElementById(trigger.getAttribute('aria-controls'));
    var item = trigger.closest('.mobile-menu__item');
    var scroller = trigger.closest('[data-scrollable-menu-blocks]');
    if (!dropdown || !item || !scroller) return;

    // Wait for the theme's open/close transition to settle before measuring.
    window.setTimeout(function () {
      if (dropdown.getBoundingClientRect().height < 1) return; // it was a close
      var top = item.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop;
      scroller.scrollTo({ top: Math.max(0, top), behavior: reduceMotion ? 'auto' : 'smooth' });
    }, 400);
  });
})();
